enum RolesId {
  COUTNRY_MANAGER = 7,
  ZONE_MANAGER = 6,
  REGION_MANAGER = 5,
  AREA_MANAGER = 4,
  HEADQUATER_MANAGER = 3,
}

export default RolesId;
